// C:\Users\mateeb.ce41ceme\Desktop\Demo\maia\frontend\src\Components\ImageViewer.js:

import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setImages } from '../redux/imageSlice';
import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import { addCircles, addGridPoints } from '../utils/cns_utils';

const ImageViewer = () => {


  const maia_size = 1024
  const grid_spacing_in_degrees = 1.0
  const maia_pixels_per_micron = maia_size / (300 * 36) //MAIA image is 36°
  const grid_spacing_in_pixels = maia_size * grid_spacing_in_degrees / 36 //From MAIA manual
  const etdrs_linewidth = 0.5
  const square_grid_linewidth = 0.5
  const contextMenuRef = useRef(null); // added contextMenu ref

  const [currentProbe, setCurrentProbe] = useState(null);

  const images = useSelector(state => state.images);
  const { centerPoint, cns_annotations, grid, loaded_pattern, etdrs } = images
  const annotations = useSelector(state => state.annotations);
  const [elementEnabled, setElementEnabled] = useState(false)
  const [resetDone, setResetDone] = useState(false)
  const dispatch = useDispatch()
  const imageElement = useRef(null);

  useEffect(() => {
    if (annotations.octMaia) {
      dispatch(setImages({
        name: 'selectedImage', value: images.maia_tgz_file.rotated_url
      }))
    } else {
      if (images.registeredUrl) {
        dispatch(setImages({
          name: 'selectedImage', value: images.registeredUrl
        }))
      } else {
        dispatch(setImages({
          name: 'selectedImage', value: images.spectralis_high_res.url
        }))
      }
    }
  }, [annotations.octMaia])
  
  const get_point = (div) => {
    return parseInt((maia_pixels_per_micron * div) / 2)
  }

  const drawGrid = () => {
    if(elementEnabled && centerPoint){
    const x = centerPoint[1]
      const y = centerPoint[0]
      if (annotations.tmmETDRS)
        addCircles(cornerstoneTools, imageElement, x, y, [
          get_point(1000)
        ], [])
      else if (annotations.fullETDRS){
        addCircles(cornerstoneTools, imageElement, x, y, [
          get_point(1000), get_point(3000), get_point(6000)], etdrs)
      } else if (annotations.degCircle) {
        
        addCircles(cornerstoneTools, imageElement, x, y, [
          get_point(9000)
        ], [])
      } else if(annotations.squareGrid){
        addGridPoints(cornerstoneTools, imageElement, grid)
      }else{
        cornerstoneTools.clearToolState(imageElement.current, 'CircleTool')
        cornerstoneTools.clearToolState(imageElement.current, 'SquareGrid')
      }
      cornerstone.updateImage(imageElement.current)
    }
  }

  useEffect(() => {
    if (elementEnabled && centerPoint) {
      drawGrid()
    }
  }, [annotations, centerPoint])




  const getToolsState = () => {
    // Get tool state for all enabled tools

    const points = cornerstoneTools.getToolState(imageElement.current, "Probe");
    if(points)
    dispatch(setImages({
      name: 'cns_annotations', value: JSON.parse(JSON.stringify(points))
    }))
  }

  const onMeasurementAdded = (e) => {
    // Get tool state for all enabled tools on measurementAdded
    getToolsState()
  }

  const onMeasurementModified = (e) => {
    // Measurement modified
    getToolsState()
  }

  // useEffect(() => {
  //   if(elementEnabled){
  //   if(!resetDone){
      
  //     cornerstoneTools.clearToolState(imageElement.current, 'Probe')
  //     dispatch(setImages({
  //       name: 'cns_annotations', value: null
  //     }))
  //     setResetDone(true)
  //     getToolsState()
  //   }
  // }
  // }, [elementEnabled])

  useEffect(() => {
    if(loaded_pattern) {
      console.log(loaded_pattern)
      cornerstoneTools.clearToolState(imageElement.current, 'Probe')
      loaded_pattern.rows?.map((item, index) => {
            cornerstoneTools.addToolState(imageElement.current, 'Probe', {
              visible: true,
              active: true,
              color: undefined,
              invalidated: true,
              handles: {
                end: {
                  x: loaded_pattern.columns[index],
                  y: item,
                  highlight: true,
                  active: true,
                },
              },
            })
      })
      cornerstone.updateImage(imageElement.current);
    }
  }, [loaded_pattern])



  // Default to spectralis_high_res.url
  let { selectedImage } = images

  useEffect(() => {
    const element = imageElement.current;
    if (selectedImage === undefined || selectedImage === null) { return }
    cornerstone.loadImage(selectedImage)
      .then((image) => {
        cornerstone.enable(element);
        cornerstone.displayImage(element, image);
        cornerstone.fitToWindow(element);
        cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool);
        cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

        cornerstoneTools.addTool(cornerstoneTools.PanTool);
        cornerstoneTools.addTool(cornerstoneTools.ZoomTool);
        cornerstoneTools.addTool(cornerstoneTools.ProbeTool);
        cornerstoneTools.addTool(cornerstoneTools.CircleTool);
        cornerstoneTools.addTool(cornerstoneTools.SquareGrid);
        


        cornerstoneTools.setToolActive('CircleTool');
        cornerstoneTools.setToolActive('SquareGrid');

        element.addEventListener('cornerstonetoolsmeasurementadded', onMeasurementAdded);
        element.addEventListener('cornerstonetoolsmeasurementmodified', onMeasurementModified);
        cornerstoneTools.setToolActive('Pan', { mouseButtonMask: 2 });
        cornerstoneTools.setToolActive('Probe', { mouseButtonMask: 1 });
        setElementEnabled(true)
        element.addEventListener('contextmenu', handleRightClick);

        
        if(cns_annotations) {
          
          cornerstoneTools.clearToolState(imageElement.current, 'Probe')
          cns_annotations.data?.map(item => {
            const cms = {...item}
            cornerstoneTools.addToolState(imageElement.current, 'Probe', {
              visible: true,
              active: true,
              color: undefined,
              invalidated: true,
              handles: {
                end: {
                  x: item.handles.end.x,
                  y: item.handles.end.y,
                  highlight: true,
                  active: true,
                },
              },
            })
          })
        }

        cornerstoneTools.clearToolState(imageElement.current, 'CircleTool')
        cornerstoneTools.clearToolState(imageElement.current, 'SquareGrid')

        drawGrid()
        

        return () => {
          element.removeEventListener('contextmenu', handleRightClick);
        };

      });

  }, [selectedImage]);
  const handleRightClick = (event) => {
    event.preventDefault();

    const probes = cornerstoneTools.getToolState(imageElement.current, 'Probe');

    if (probes && probes.data && probes.data.length > 0) {
      const clickCoords = cornerstone.pageToPixel(imageElement.current, event.pageX, event.pageY);
      let overProbe = null;

      probes.data.some(probe => {
        const distance = Math.sqrt(Math.pow(clickCoords.x - probe.handles.end.x, 2) + Math.pow(clickCoords.y - probe.handles.end.y, 2));
        if (distance <= 7) {
          overProbe = probe;
          return true; // Breaking out of the loop
        }
        return false;
      });

      if (overProbe) {
        setCurrentProbe(overProbe);
        const boundingRect = imageElement.current.getBoundingClientRect();
        const relativeX = event.clientX - boundingRect.left;
        const relativeY = event.clientY - boundingRect.top;
        showContextMenu(relativeX, relativeY);
      }
    }
  }

  const showContextMenu = (x, y) => {
    const menu = contextMenuRef.current; // use the ref here
    menu.style.top = `${y + 10}px`;
    menu.style.left = `${x + 10}px`;
    menu.style.display = 'block';
    menu.style.opacity = 0;
    setTimeout(() => menu.style.opacity = 1, 50);
  }

  const hideContextMenu = () => {
    const menu = contextMenuRef.current; // use the ref here
    menu.style.display = 'none';
  }

  const deleteProbe = () => {
    const probes = cornerstoneTools.getToolState(imageElement.current, 'Probe');
    if (probes && probes.data) {
      const index = probes.data.indexOf(currentProbe);
      if (index > -1) {
        probes.data.splice(index, 1);
        cornerstone.updateImage(imageElement.current);  // Redraw the image with updated tool state
        getToolsState()
      }
    }
    hideContextMenu();
  }

  return (
    
    <div style={{ position: 'relative' }}>
      <div
        ref={imageElement}
        style={{ width: '100%', height: 'calc(100vh - 40px)' }}
        onClick={hideContextMenu}
      ></div>
      <div
        ref={contextMenuRef} // attach the ref here
        style={{
          display: 'none',
          position: 'absolute',
          backgroundColor: 'white',
          border: '1px solid #ccc',  // Light gray border
          borderRadius: '5px',       // Rounded corners
          boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',  // Drop shadow
          transition: 'opacity 0.2s ease-in-out',        // Smooth fade-in effect
          zIndex: 1000
        }}
      >
        <div
          style={{
            padding: '10px',
            cursor: 'pointer',
            borderBottom: '1px solid #eee'  // Subtle bottom border
          }}
          onClick={deleteProbe}
        >
          Delete this probe?
        </div>
      </div>
      </div>
  );
};

export default ImageViewer;